import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ITaxRateShiftsFeature } from './taxrate-shifts.feature.state';
import { TaxRateShiftsState } from './taxrate-shifts.state';

export const getTaxRateShiftsState: MemoizedSelector<ITaxRateShiftsFeature, TaxRateShiftsState> = createFeatureSelector<TaxRateShiftsState>(
  nameof<ITaxRateShiftsFeature>('taxRateShiftsFeature')
);

export const getIsLoading = createSelector(getTaxRateShiftsState, (state: TaxRateShiftsState) => state.isLoading);
export const getFailures = createSelector(getTaxRateShiftsState, (state: TaxRateShiftsState) => state.failures);
export const getTaxRateShifts = createSelector(getTaxRateShiftsState, (state: TaxRateShiftsState) => state.taxrateShifts);
